module.exports = __webpack_public_path__ + "img/icon-lupa.a9eab34b.svg";